import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Award, Building2, FileText, Users } from 'lucide-react';
const stats = [{
  icon: FileText,
  value: '20K',
  label: 'Policies Issued',
  color: 'text-red-600',
  bgColor: 'bg-red-50'
}, {
  icon: Users,
  value: '5K',
  label: 'Happy Customers',
  color: 'text-red-600',
  bgColor: 'bg-red-50'
}, {
  icon: Building2,
  value: '120+',
  label: 'Professional Team',
  color: 'text-red-600',
  bgColor: 'bg-red-50'
}, {
  icon: Award,
  value: '96%',
  label: 'Success Rating',
  color: 'text-red-600',
  bgColor: 'bg-red-50'
}];
export function AboutInsurance() {
  return <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white" data-id="element-107">
      <div className="container mx-auto px-4 md:px-6" data-id="element-108">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-20" data-id="element-109">
          {/* Left: Image Section */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative order-2 lg:order-1" data-id="element-110">
            <div className="relative" data-id="element-111">
              {/* Insurance consultation/handshake image */}
              <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl overflow-hidden aspect-[4/5] max-w-md mx-auto shadow-2xl" data-id="element-112">
                <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&h=750&fit=crop" alt="Professional insurance consultation and partnership" className="w-full h-full object-cover" data-id="element-113" />

                {/* Decorative badge - NAICOM Certified */}
                <div className="absolute top-6 left-6 bg-white rounded-2xl shadow-lg p-4 flex items-center gap-3" data-id="element-114">
                  <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center" data-id="element-115">
                    <Award className="w-5 h-5 text-brand-red" data-id="element-116" />
                  </div>
                  <div data-id="element-117">
                    <p className="text-xs font-semibold text-gray-900" data-id="element-118">
                      NAICOM
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-119">Certified</p>
                  </div>
                </div>

                {/* Decorative badge - Zylus Group */}
                <div className="absolute bottom-6 right-6 bg-white rounded-2xl shadow-lg p-4 text-center" data-id="element-120">
                  <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-121">
                    <Building2 className="w-6 h-6 text-white" data-id="element-122" />
                  </div>
                  <p className="text-sm font-bold text-brand-black" data-id="element-123">
                    Zylus Group
                  </p>
                  <p className="text-xs text-gray-600" data-id="element-124">International</p>
                </div>

                {/* Decorative arrow */}
                <div className="absolute top-8 right-8 w-12 h-12 bg-brand-red rounded-full flex items-center justify-center shadow-lg" data-id="element-125">
                  <ArrowRight className="w-6 h-6 text-white" data-id="element-126" />
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -top-4 -left-4 w-8 h-8 border-4 border-brand-red rounded-full" data-id="element-127" />
              <div className="absolute top-1/2 -left-6 w-12 h-0.5 bg-brand-red" data-id="element-128" />
              <div className="absolute top-1/2 -right-6 w-8 h-8 bg-brand-red rounded-full" data-id="element-129" />
            </div>
          </motion.div>

          {/* Right: Content Section */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2" data-id="element-130">
            <div className="inline-block px-4 py-2 bg-red-50 text-brand-red-dark rounded-full text-sm font-medium mb-6" data-id="element-131">
              About Absolute Insurance Brokers
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-brand-black mb-6 leading-tight" data-id="element-132">
              We Provide the Best{' '}
              <span className="text-brand-red" data-id="element-133">Insurance Policy</span>
            </h2>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-134">
              Absolute Insurance Brokers Ltd is a subsidiary of{' '}
              <span className="font-semibold text-brand-black" data-id="element-135">
                Zylus Group International
              </span>
              , a leading indigenous real estate and investment group based in
              Lagos, Nigeria, with operations across the federation.
            </p>

            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-136">
              We are a fully licensed and{' '}
              <span className="font-semibold text-brand-black" data-id="element-137">
                NAICOM-certified
              </span>{' '}
              insurance brokerage firm, providing innovative, technology-driven
              insurance solutions for individuals, corporations, and
              institutions.
            </p>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-138">
              <Button size="lg" className="shadow-lg shadow-brand-red/20" data-id="element-139">
                Get Started <ArrowRight className="ml-2 h-5 w-5" data-id="element-140" />
              </Button>

              <div className="flex items-center gap-3" data-id="element-141">
                <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center" data-id="element-142">
                  <Users className="w-6 h-6 text-brand-red" data-id="element-143" />
                </div>
                <div data-id="element-144">
                  <p className="text-2xl font-bold text-brand-black" data-id="element-145">1.80m</p>
                  <p className="text-sm text-gray-600" data-id="element-146">Total Active Users</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Stats Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-2 md:grid-cols-4 gap-8 bg-white rounded-3xl shadow-lg p-8 md:p-12" data-id="element-147">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center" data-id="element-148">
              <div className={`w-16 h-16 ${stat.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-4`} data-id="element-149">
                <stat.icon className={`w-8 h-8 ${stat.color}`} data-id="element-150" />
              </div>
              <p className="text-3xl md:text-4xl font-bold text-brand-black mb-2" data-id="element-151">
                {stat.value}
              </p>
              <p className="text-sm text-gray-600" data-id="element-152">{stat.label}</p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}